import Recaptcha from '@components/App/RecaptchaWidget'
import { Input } from '@lib/components'
import { IconWorld } from '@lib/icons'
import { SitemapAudit } from '@lib/images'
import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { useState } from 'react'

import type { ModalProps } from '@/types/modal'
import { prepareUrl } from './components/Tabs/utils'
import { useStartCrawl } from './hooks'
import css from './Report.module.scss'

type Props = {
  teamId?: string
  folderId?: string | null
  initialUrl?: string
}

// The sitemap audit flow: one url, one button. No import tabs, no pages/SEO
// choice, no excluded paths — the crawl is always ingested as a report.
const Report: React.FC<ModalProps & Props> = ({
  teamId,
  folderId,
  closeButton,
  initialUrl = '',
}) => {
  const [url, setUrl] = useState(initialUrl)

  const { loading, inputError, startCrawl } = useStartCrawl({
    teamId,
    folderId,
    metaTag: true,
    blocks: false,
    blocksContent: false,
    excludedUrls: [],
    asReport: true,
  })

  const handleSubmit = (e?: React.FormEvent) => {
    e?.preventDefault()
    startCrawl(url)
  }

  const onBlur = () => {
    setUrl(prepareUrl(url))
  }

  return (
    <Recaptcha>
      <div className={css.container}>
        <div className={css.close}>{closeButton}</div>

        <div className={css.logo}>
          <SitemapAudit />
        </div>

        <div className={css.title}>Sitemap audit</div>

        <p className={css.description}>
          Enter an address of a website to collect page URLs and status. A
          second crawl will show changes.
        </p>

        <form className={css.form} onSubmit={handleSubmit}>
          <div className={css.input}>
            <Input
              autoFocus
              initialValue={url}
              placeholder="https://website.com"
              name="url"
              type="normal"
              icon={<IconWorld />}
              onChange={setUrl}
              error={inputError ? 'Please enter a valid URL' : undefined}
              autoComplete="off"
              spellCheck="false"
              onBlur={onBlur}
              onSubmit={() => handleSubmit()}
            />
          </div>

          <div className={css.button}>
            <Button
              className={css.wide_button}
              label="Start audit"
              loading={loading}
              disabled={!url}
              data-testid="crawl"
              onClick={handleSubmit}
            />
          </div>
        </form>
      </div>
    </Recaptcha>
  )
}

export default Report
